module.exports = __webpack_public_path__ + "static/media/aerovinum-2.81a3a2d3.jpg";